<iframe  [src]='safeUrl'  height="750px" width="100%"> </iframe>
